import {streamify} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'
/**
 * @implements UseCase
 */
@streamify('execute')
class SaveLastAdsSearchUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.repository
   * @param {Object} deps.config
   */
  constructor({repository, config}) {
    super({repository, config})

    this._repository = repository
    this._config = config
  }

  /**
   * @return {Promise<Object, Error>} list of searches
   */
  async execute({listingSectionId, title, pageName, query, params}) {
    return this._repository.saveLastAdsSearch({listingSectionId, title, pageName, query, params})
  }
}

export default SaveLastAdsSearchUseCase
